import { jsx as _jsx } from "react/jsx-runtime";
import { Theme } from '@streem/ui-react';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
export const FullscreenPortal = ({ children, className }) => {
    const domNode = useRef(document.createElement('div'));
    useEffect(() => {
        const child = domNode.current;
        document.body.appendChild(child);
        return () => {
            document.body.removeChild(child);
        };
    }, [domNode]);
    useEffect(() => {
        domNode.current.className = className;
    }, [domNode, className]);
    return createPortal(_jsx("div", { style: {
            position: 'absolute',
            zIndex: Theme.layers.callFrame,
            bottom: 0,
            left: 0,
            right: 0,
        }, "data-testid": "full-screen-portal", children: children }), domNode.current);
};
//# sourceMappingURL=fullscreen_portal.js.map